import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of } from 'rxjs';

import { PaginationResponse } from '../../../shared/models/pagination-response.model';
import { PriceAndAvailability } from './models/price-and-availability.model';
import * as PriceAndAvailabiltyActions from './price-and-availability.actions';
import { PriceAndAvailabilityService } from './price-and-availability.service';

export const loadPriceAndAvailability$: ReturnType<typeof createEffect> = createEffect(
  (actions$ = inject(Actions), priceAndAvailabilityService = inject(PriceAndAvailabilityService)) => {
    return actions$.pipe(
      ofType(PriceAndAvailabiltyActions.loadPriceAndAvailability),
      mergeMap(() => {
        return priceAndAvailabilityService
          .getPriceAndAvailability()
          .pipe(
            map((response: PaginationResponse<PriceAndAvailability[]>) => {
              return PriceAndAvailabiltyActions.loadPriceAndAvailabilitySuccess({
                priceAndAvailabilityResponse: response,
              });
            }),
            catchError(error =>
              of(
                PriceAndAvailabiltyActions.loadPriceAndAvailabilityFailure({
                  error: error?.message ?? 'Unknown error loading price and availability',
                })
              )
            )
          );
      })
    );
  },
  { functional: true }
);

export const priceAndAvailabilityEffects: object = { loadPriceAndAvailability$ };
